// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__+-t41","loaderContent":"Loader_loaderContent__Tq2Xh","hasBox":"Loader_hasBox__kXAIC"};